module.exports = __webpack_public_path__ + "img/articulating_screen_illustration.84139ba2.svg";